module.exports = __webpack_public_path__ + "static/media/debt.bfda916b.png";